export const AccountLockedForMisbehavior = 1;
export const IncorrectEmailOrPassword = 2;
export const TryAgain = 3;
export const FatalError = 4;
export const BlankEmail = 5;
export const InvalidEmail = 6;
export const BlankPassword = 7;
export const SocialLoginNonPatient = 8;
export const SocialLoginOther = 9;
export const SocialLoginRequestExpired = 10;
export const AccountLockedTooManyAuthFailures = 11;
export const SocialLoginCannotBeLinkedForMfaUsers = 12;
